import api from "./api";

// LOGIN
export const login = async (
  email: string,
  password: string,
  rememberMe = true
) => {
  const response = await api.post("/login", {
    email,
    password,
    remember_me: rememberMe,
  });
  console.log("🔎 Raw login response:", response.data);

  const token = response.data?.data?.token;
  const rawUser = response.data?.data?.user;
  const permissions = response.data?.data?.permissions;
  const roles = response.data?.data?.roles;

  const user = rawUser
    ? {
        ...rawUser,
        ...(Array.isArray(permissions) ? { permissions } : {}),
        ...(Array.isArray(roles) && !rawUser.roles
          ? {
              roles: roles.map((name: string) =>
                typeof name === "string" ? { name } : name
              ),
            }
          : {}),
      }
    : rawUser;

  console.log("👉 Extracted user in auth.ts:", user);

  if (token) localStorage.setItem("token", token);

  return { token, user };
};

// LOGOUT
export const logout = async () => {
  try {
    await api.post("/logout");
  } finally {
    localStorage.removeItem("token");
  }
};

// REGISTER
export const register = async (data: any) => {
  const response = await api.post("/register", data);

  const token = response.data?.data?.token;
  const user = response.data?.data?.user;

  if (token) {
    localStorage.setItem("token", token);
  }

  return { token, user };
};

// FORGOT PASSWORD
export const forgotPassword = async (email: string) => {
  const response = await api.post("/forgot/password", { email });
  return response.data;
};

// RESET PASSWORD
export const resetPassword = async (data: {
  email: string;
  password: string;
  password_confirmation: string;
  token?: string;
}) => {
  const response = await api.post("/password/reset", data);
  return response.data;
};
// CHECK SUBDOMAIN AVAILABILITY
export const checkSubdomain = async (subdomain: string) => {
  const response = await api.get(`/check-subdomain?subdomain=${subdomain}`);
  return response.data;
};

// IMPERSONATE (admin switch to employee). Sends employee id as user_id and optional pin_code in POST body.
export const impersonate = async (employeeId: number, pinCode?: string) => {
  const body: { user_id: number; pin_code?: string } = { user_id: employeeId };
  if (pinCode != null && pinCode !== "") body.pin_code = pinCode;
  const response = await api.post("/admin/impersonate", body);
  const payload = response.data?.data ?? response.data;
  const accessToken = payload?.access_token ?? payload?.token;
  const userData = payload?.user;
  const impersonationData = payload?.impersonation;
  const permissions = payload?.permissions;
  const roles = payload?.roles;
  if (!accessToken || !userData) {
    throw new Error("Invalid impersonation response");
  }
  const user = {
    ...userData,
    ...(Array.isArray(permissions) ? { permissions } : {}),
    ...(Array.isArray(roles) && !userData.roles
      ? {
          roles: roles.map((name: string) =>
            typeof name === "string" ? { name } : name
          ),
        }
      : {}),
    impersonation: impersonationData,
  };
  return { accessToken, user, impersonation: impersonationData };
};
